import { combineReducers } from 'redux';
import { loginStateReducer, userInfStateReducer } from './login/login';

const rootReducer = combineReducers({
    loginStateReducer,
    userInfStateReducer,
})

export default rootReducer